module.exports = __webpack_public_path__ + "img/icon-arrow-down-solid.0614c396.svg";